import {
  OMS_LOOKUP_SUCCESS,
  INITIATE_OMS_LOOKUP,
  OMS_LOOKUP_FAILURE,
  SET_CREDENTIALS,
  OMS_IS_AUTHENTICATING,
} from '@src/app/login/oms/actions';
import { RootAction } from '@src/app/_redux';
import { combineReducers } from 'redux';
import { USER_LOGOUT } from '@src/app/header/actions';

export type State = {
  isLoginSuccessful: boolean;
  readonly authenticating: boolean;
  isFailure: boolean;
  credentials: any | null;
};

export const reducer = combineReducers<State, RootAction>({
  isLoginSuccessful: (state = false, action) => {
    switch (action.type) {
      case OMS_LOOKUP_SUCCESS:
        return true;
      case USER_LOGOUT:
        return false;
      default:
        return state;
    }
  },
  authenticating: (state = false, action) => {
    switch (action.type) {
      case OMS_LOOKUP_SUCCESS:
      case OMS_LOOKUP_FAILURE:
      case '@@INIT':
        return false;
      case OMS_IS_AUTHENTICATING:
        return action.payload;
      default:
        return state;
    }
  },
  isFailure: (state = false, action) => {
    switch (action.type) {
      case USER_LOGOUT:
      case INITIATE_OMS_LOOKUP:
      case OMS_LOOKUP_SUCCESS:
        return false;
      case OMS_LOOKUP_FAILURE:
        return true;
      default:
        return state;
    }
  },
  credentials: (state = null, action) => {
    switch (action.type) {
      case SET_CREDENTIALS:
        return action.payload;
      case USER_LOGOUT:
        return null;
      default:
        return state;
    }
  },
});
